/**
 * Barra de busca da lista de resumos (F12 Wave 8).
 * Usa debounce de 400ms para reduzir chamadas ao backend.
 */

import { useEffect, useState } from 'react';
import { TextField } from '../../design-system/components/TextField';

interface SummarySearchBarProps {
  value: string;
  onChange: (v: string) => void;
  debounceMs?: number;
}

export function SummarySearchBar({ value, onChange, debounceMs = 400 }: SummarySearchBarProps) {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  useEffect(() => {
    if (local === value) return;
    const timeout = setTimeout(() => onChange(local), debounceMs);
    return () => clearTimeout(timeout);
  }, [local, value, onChange, debounceMs]);

  return (
    <div className="summary-search-bar">
      <TextField
        label="Buscar resumos"
        placeholder="Buscar por palavras do resumo executivo..."
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        type="search"
        data-testid="summary-search-input"
      />
    </div>
  );
}
